<template>
  <div class="enterpriseScale">
    <div class="flex-box">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="企业测评" key="evaluation"></a-tab-pane>
      </a-tabs>
      <a-button @click="onBack" v-if="isBack">返回</a-button>
    </div>
    <div class="title">
      <span class="desc1"></span>
      <span class="desc2">{{
        isTech ? "科技型中小企业测评" : "企业规模类型自测"
      }}</span>
    </div>
    <div class="remark" v-if="isTech">
      特别提示：科技型中小企业的研发费用加计扣除比例提高到75%
    </div>

    <a-form-model
      class="scale-form"
      ref="scaleRuleForm"
      :model="scaleForm"
      :rules="scaleRules"
      v-if="!isTech"
    >
      <!-- <a-form-model-item label="请输入企业名称" prop="companyName">
				<a-input v-model="scaleForm.companyName" />
			</a-form-model-item>-->
      <a-form-model-item label="请输入企业名称" prop="companyName">
        <a-select
          show-search
          v-model="scaleForm.companyName"
          :autoClearSearchValue="false"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="optionLoading ? undefined : null"
          @search="handleSearch"
          @blur="handleBlur"
          @change="handleChange"
          style="width: 300px"
        >
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option
            v-for="(company, index) in companyList"
            :key="index"
            :value="company"
            >{{ company }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="请选择企业所属行业：" prop="industryCode">
        <a-radio-group v-model="scaleForm.industryCode">
          <a
            href="https://img.gongsibao.com/%E5%9B%BD%E6%B0%91%E7%BB%8F%E6%B5%8E%E8%A1%8C%E4%B8%9A%E5%88%86%E7%B1%BB.docx"
            target="_blank"
            >查阅《国民经济行业分类》（GB/T4754-2017）</a
          >
          <a-radio
            :value="index + 1"
            v-for="(item, index) in radioList"
            :key="index + 'radioList'"
            >{{ item }}</a-radio
          >
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="上一年末从业人数："
        prop="lastYearEndEmpNum"
        v-if="
          scaleForm.industryCode != 1 &&
          scaleForm.industryCode != 3 &&
          scaleForm.industryCode != 13 &&
          scaleForm.industryCode != ''
        "
      >
        <a-input v-model="scaleForm.lastYearEndEmpNum" />人
      </a-form-model-item>
      <a-form-model-item
        label="上一年末营业收入："
        prop="lastYearEndOperatingIncome"
        v-if="
          scaleForm.industryCode != 15 &&
          scaleForm.industryCode != 16 &&
          scaleForm.industryCode != ''
        "
      >
        <a-input v-model="scaleForm.lastYearEndOperatingIncome" />万元
      </a-form-model-item>
      <a-form-model-item
        label="上一年末资产总额："
        prop="lastYearEndTotalAssets"
        v-if="
          scaleForm.industryCode != '' &&
          (scaleForm.industryCode == 3 ||
            scaleForm.industryCode == 13 ||
            scaleForm.industryCode == 15)
        "
      >
        <a-input v-model="scaleForm.lastYearEndTotalAssets" />万元
      </a-form-model-item>
    </a-form-model>

    <a-form-model
      class="technology-form"
      ref="technologyRuleForm"
      :model="technologyForm"
      :rules="technologyRules"
      v-if="isTech"
    >
      <!-- <a-form-model-item label="请输入企业名称" prop="companyName">
				<a-input v-model="technologyForm.companyName" />
			</a-form-model-item> -->
      <a-form-model-item label="请输入企业名称" prop="companyName">
        <a-select
          show-search
          v-model="technologyForm.companyName"
          :autoClearSearchValue="false"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="optionLoading ? undefined : null"
          @search="handleSearch"
          @blur="handleBlur"
          @change="handleChange"
          style="width: 300px"
        >
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option
            v-for="(company, index) in companyList"
            :key="index"
            :value="company"
            >{{ company }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="注册地址：" prop="registerAddress">
        <a-radio-group v-model="technologyForm.registerAddress">
          <div class="question">
            企业为在中国境内（不包括港、澳、台地区）注册的居民企业
          </div>
          <a-radio :value="1">符合</a-radio>
          <a-radio :value="0">不符合</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="企业规模：" prop="enterpriseSize">
        <a-radio-group v-model="technologyForm.enterpriseSize">
          <div class="question">
            企业职工总数不超过500人、年销售收入不超过2亿元、资产总额不超过2亿元
          </div>
          <a-radio :value="1">符合</a-radio>
          <a-radio :value="0">不符合</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="产品及服务范围：" prop="productAndServiceRange">
        <a-radio-group v-model="technologyForm.productAndServiceRange">
          <div class="question">
            企业提供的产品和服务不属于国家规定的禁止、限制和淘汰类
          </div>
          <a-radio :value="1">符合</a-radio>
          <a-radio :value="0">不符合</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="企业信用：" prop="enterpriseCredit">
        <a-radio-group v-model="technologyForm.enterpriseCredit">
          <div class="question">
            企业在填报上一年及当年内未发生重大安全、重大质量事故和严重环境违法、科研严重失信行为，且企业未列入经营异常名录和严重违法失信企业名单
          </div>
          <a-radio :value="1">符合</a-radio>
          <a-radio :value="0">不符合</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>

    <ul class="description" v-if="!isTech">
      <li>说明：</li>
      <li>
        1、从业人员，是指期末从业人员数，没有期末从业人员数的，采用全年平均人员数代替。
      </li>
      <li>
        2、营业收入，工业、建筑业、限额以上批发和零售业、限额以上住宿和餐饮业以及其他设置主营业务收入指标的行业，采用主营业务收入；限额以下批发与零售业企业采用商品销售额代替；限额以下住宿与餐饮业企业采用营业额代替；农、林、牧、渔业企业采用营业总收入代替；其他未设置主营业务收入的行业，采用营业收入指标。
      </li>
      <li>3、资产总额，采用资产总计代替。</li>
    </ul>
    <div class="btn">
      <a-button type="primary" :loading="loading" @click="onSubmit">{{
        loading ? "测评中" : "测评"
      }}</a-button>
      <!-- <a-button style="margin-left: 20px;" @click="resetForm">
				{{isTech?'上一步':'取消'}}
			</a-button>-->
    </div>
  </div>
</template>

<script>
import { enterpriseSizeEva, enterpriseTechEva } from "@/api/enterpriseScale";
import { getCompanyInfo } from "@/api/enterpriseHighNew";
import {setHeight} from "@/utils/zgzx";
export default {
  data() {
    return {
      loading: false,
      isTech: false,
      activeName: "evaluation",
      radioList: [
        "农、林、牧、渔业",
        "工业",
        "建筑业",
        "批发业",
        "零售业",
        "交通运输业",
        "仓储业",
        "邮政业",
        "住宿业",
        "餐饮业",
        "信息传输业",
        "软件和信息技术服务业",
        "房地产开发经营",
        "物业管理",
        "租赁和商务服务业",
        "其他未列明行业",
      ],
      scaleForm: {
        industryCode: "",
        lastYearEndOperatingIncome: "",
        lastYearEndEmpNum: "",
        lastYearEndTotalAssets: "",
        companyName: "",
      },
      scaleRules: {
        industryCode: [
          {
            required: true,
            message: "请选择企业所属行业",
            trigger: "change",
          },
        ],
        lastYearEndOperatingIncome: [
          {
            required: true,
            pattern: new RegExp(/^[1-9]\d*$/, "g"),
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        lastYearEndEmpNum: [
          {
            required: true,
            pattern: new RegExp(/^[1-9]\d*$/, "g"),
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        lastYearEndTotalAssets: [
          {
            required: true,
            pattern: new RegExp(/^[1-9]\d*$/, "g"),
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "change",
          },
        ],
      },

      technologyForm: {
        registerAddress: "",
        enterpriseSize: "",
        productAndServiceRange: "",
        enterpriseCredit: "",
        companyName: "",
      },
      technologyRules: {
        registerAddress: [
          {
            required: true,
            message: "请选择注册地址是否符合要求",
            trigger: "change",
          },
        ],
        enterpriseSize: [
          {
            required: true,
            message: "请选择企业规模是否符合要求",
            trigger: "change",
          },
        ],
        productAndServiceRange: [
          {
            required: true,
            message: "请选择产品及服务范围是否符合要求",
            trigger: "change",
          },
        ],
        enterpriseCredit: [
          {
            required: true,
            message: "请选择企业信用是否符合要求",
            trigger: "change",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "change",
          },
        ],
      },
      companyList: [],
      optionLoading: false,
      isBack: false,
    };
  },
  methods: {
    handleBlur(value) {
      if (value) {
        if (this.isTech) {
          this.technologyForm.companyName = value;
        } else {
          this.scaleForm.companyName = value;
        }
      }
    },
    handleChange(value) {
      if (this.isTech) {
        this.technologyForm.companyName = value;
      } else {
        this.scaleForm.companyName = value;
      }
      Object.assign(this, {
        companyList: [],
        optionLoading: false,
      });
    },
    handleSearch(value) {
      if (this.isTech) {
        this.technologyForm.companyName = value;
      } else {
        this.scaleForm.companyName = value;
      }
      this.optionLoading = true;
      let data = {
        name: value,
      };
      getCompanyInfo(data)
        .then((res) => {
          this.optionLoading = false;
          if (res.data) this.companyList = [...new Set(res.data)];
        })
        .catch((err) => console.log(err));
    },

    onSubmit() {
      if (this.isTech) {
        this.$refs.technologyRuleForm.validate((valid) => {
          if (valid) {
            this.enterpriseTechEvaPro();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.$refs.scaleRuleForm.validate((valid) => {
          if (valid) {
            this.enterpriseSizeEvaPro();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    /* resetForm() {
			if(this.isTech){
				this.$refs.technologyRuleForm.resetFields();
			}else{
				this.$refs.scaleRuleForm.resetFields();
			}
		}, */

    //企业规模类型测评
    enterpriseSizeEvaPro() {
      this.loading = true;
      enterpriseSizeEva(this.scaleForm)
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            res.data.companyName = this.scaleForm.companyName;
            localStorage.setItem("scaleResult", JSON.stringify(res.data));
            let url = this.isTech
              ? "?isTech=true"
              : this.isBack
              ? "?source=zjtx"
              : "";
            this.$router.push("/enterpriseScaleH5/result" + url);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //科技型中小企业测评
    enterpriseTechEvaPro() {
      this.loading = true;
      enterpriseTechEva(this.technologyForm).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          res.data.companyName = this.technologyForm.companyName;
          localStorage.setItem(
            "techParams",
            JSON.stringify(this.technologyForm)
          );
          localStorage.setItem("techResult", JSON.stringify(res.data));
          let url = this.isTech ? "?isTech=true" : "";
          this.$router.push("/enterpriseScaleH5/result" + url);
        }
      });
    },

    onBack() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.$route.query.isTech == "true") {
      this.isTech = true;
    }
    setTimeout(() => {
      setHeight();
    }, 1000)
  },
  created() {
    if (this.$route.query.source == "zjtx") {
      this.isBack = true;
    }
  },
};
</script>

<style lang="less" scoped>
.enterpriseScale {
  padding: 20px;
  .flex-box {
    display: flex;
    height: 36px;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    // margin-bottom: 16px;
  }

  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 12px 0;
  }

  ::v-deep .ant-tabs-tab {
    padding-top: 0;
  }

  ::v-deep .ant-tabs-ink-bar {
    width: 64px !important;
    background-color: #0072f7;
  }

  .title {
    margin-top: 46px;
    display: flex;
    align-items: center;

    .desc1 {
      display: inline-block;
      width: 3px;
      height: 14px;
      background: #0072f7;
    }

    .desc2 {
      margin-left: 7px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 16px;
    }
  }

  .remark {
    color: #999999;
    margin-top: 14px;
    padding-left: 12px;
  }

  .scale-form {
    padding-left: 12px;
    margin-top: 20px;

    .ant-form-item:not(:nth-child(2)) {
      display: flex;
      flex-wrap: wrap;
    }

    .ant-radio-wrapper {
      margin-top: 22px;
      margin-right: 36px;
      width: 35%;
    }

    a {
      display: flex;
      color: #0072f7;
    }

    .ant-input {
      width: 140px;
      border-radius: 2px;
      margin: 0 10px;
    }

    ::v-deep .ant-form-explain {
      margin-left: 10px;
    }
  }

  .technology-form {
    // padding-left: 12px;
    margin-top: 20px;

    .ant-form-item:first-child {
      display: flex;
      flex-wrap: wrap;
    }
    ::v-deep .ant-form-item-control-wrapper {
      padding-left: 12px;

      .question {
        margin-bottom: 20px;
      }
    }
  }

  .description {
    background-color: #fafafa;
    padding: 20px;
    line-height: 27px;

    li {
      color: #666666;
    }
  }

  .btn {
    text-align: center;
    margin-top: 40px;

    .ant-btn {
      width: 133px;
      height: 40px;
      border-radius: 2px;
      font-size: 16px;
      color: #999999;
    }

    .ant-btn-primary {
      background: #0072f7;
      color: #ffffff;
    }
  }
}
</style>
